const userController = (function ($) {
    "use strict";
    return {

        /**
         * Logout the current user, when finished goes to home page.
         */
        logout: () => {
            return $.get('/@users/logout');
        },

        login: data => $.post('/@users/login', data),
        forgotPassword: (login, orgnr) => {
            return $.post('/@users/forgot-password', {
                email: login,
                orgnr: orgnr
            }, function (response) {
                return response;
            });
        }
    };

})(jQuery);

